module.exports = __webpack_public_path__ + "img/arrow_green.8bca7340.svg";